
import { useEffect, useState } from "react"
import InfoCard from "./infoCard"
import { motion } from 'framer-motion';
import { TfiAngleRight } from "react-icons/tfi";
import ScrollContainer from "react-indiana-drag-scroll";
import { PropTypes } from 'prop-types';
const AlumniCards = ({ ourAlumni }) => {
    const [isBack, setIsBack] = useState(false)
    const [totalCards, setTotalCards] = useState(0)
    const alumniCards = ourAlumni?.alumniHallOfFame?.map(item =>
        item?.route?.path

    )

    useEffect(() => {
        setTotalCards(alumniCards?.length / 4)
    }, [alumniCards])


    return (
        <ScrollContainer horizontal className="flex w-full overflow-x-hidden whitespace-nowrap ">
            <motion.div
                initial={{ x: 0 }}
                animate={{ x: isBack ? "-100%" : 0 }}
                transition={{ duration: 0.5 }}
                className="flex flex-nowrap gap-10"
            >
                {/* <div

                    className="flex shrink-0 max-w-full lg:max-w-[65rem] xl:max-w-[75rem] 2xl:max-w-7xl flex-col gap-8 ">
                    <InfoCard />
                    <InfoCard />
                    <InfoCard />
                    <InfoCard />
                </div>
                <div
                    className="flex shrink-0 max-w-full lg:max-w-[65rem] xl:max-w-[75rem] 2xl:max-w-7xl flex-col gap-8">
                    <InfoCard />
                    <InfoCard />
                    <InfoCard />
                    <InfoCard />
                </div> */}
                {
                    totalCards > 1 ? Array.from({ length: totalCards }, (_, i) => (
                        <div key={i}
                            className="flex shrink-0 w-full flex-col gap-8"
                        >
                            {alumniCards?.slice(i * 4, i * 4 + 4).map((item, index) => (
                                <InfoCard key={index} item={item} />
                            ))}
                        </div>
                    )) :
                        <div
                            className="flex shrink-0 w-full flex-col gap-8"
                        >
                            {
                                alumniCards?.map((item, index) => (
                                    <InfoCard key={index} item={item} />
                                ))
                            }
                        </div>



                }

            </motion.div>
            <div className="absolute top-1/2 -right-[2%] 2xl:-right-[5%] transform -translate-y-1/2">
                <button onClick={() => setIsBack(!isBack)} className=" flex items-center justify-center text-slate-900 font-bold text-2xl ">{
                    isBack ? <TfiAngleRight className="transform rotate-180 " size={50} /> : <TfiAngleRight size={50} />

                }</button>
            </div>
        </ScrollContainer>
    )
}
AlumniCards.propTypes = {
    ourAlumni: PropTypes.any
}
export default AlumniCards